module.exports = __webpack_public_path__ + "static/media/uniksystem.f944134e.svg";